/* tslint:disable:prefer-conditional-expression */
import * as React from 'react';
import cx from 'classnames';
import styles from './CartQuantityWidget.css';
var QuantityChangeAction;
(function (QuantityChangeAction) {
    QuantityChangeAction["ADD"] = "ADD";
    QuantityChangeAction["SUBTRACT"] = "SUBTRACT";
    QuantityChangeAction["INPUT"] = "INPUT";
})(QuantityChangeAction || (QuantityChangeAction = {}));
export default class CartQuantityWidget extends React.Component {
    constructor(props) {
        super(props);
        // The number -> string and back conversions is pretty odd and requires cleanup
        this.changeQuantity = (mode) => {
            const { quantity } = this.state;
            const { minQuantity, handleQuantityChange } = this.props;
            let newQuantity = quantity;
            const quantityNum = Number(quantity);
            return e => {
                switch (mode) {
                    case QuantityChangeAction.ADD:
                        newQuantity = (quantityNum + 1).toString();
                        break;
                    case QuantityChangeAction.SUBTRACT:
                        if (quantityNum <= minQuantity) {
                            newQuantity = minQuantity.toString();
                            break;
                        }
                        newQuantity = (quantityNum - 1).toString();
                        break;
                    case QuantityChangeAction.INPUT:
                        const newQuantityNum = Math.floor(Number(e.target.value.substr(0, 3)));
                        if (isNaN(newQuantityNum) || newQuantityNum < minQuantity) {
                            newQuantity = '';
                        }
                        else {
                            newQuantity = newQuantityNum.toString();
                        }
                        break;
                    default:
                        newQuantity = quantity;
                }
                if (Number(newQuantity) >= minQuantity && typeof handleQuantityChange === 'function') {
                    handleQuantityChange(newQuantity);
                }
                this.setState({ quantity: newQuantity });
            };
        };
        this.handleBlur = () => {
            if (this.state.quantity === '') {
                this.setState({ quantity: this.props.quantity || '' });
            }
        };
        // TODO: Since the quantity represents a UI numeric value, it's better
        // to make the type as string instead of string | number.
        this.state = {
            quantity: props.quantity || props.minQuantity.toString()
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.state.quantity !== nextProps.quantity) {
            this.setState({ quantity: nextProps.quantity });
        }
    }
    render() {
        const { minQuantity, className, disabled } = this.props;
        const { quantity } = this.state;
        return (<div className={cx(styles['cart-quantity-widget'], className)}>
				<button className={cx(styles['quantity-button'], styles['quantity-subtract'])} onClick={this.changeQuantity(QuantityChangeAction.SUBTRACT)} disabled={disabled || Number(quantity) <= minQuantity} data-aid="subtract-quantity">
					{' '}
					&ndash;{' '}
				</button>
				<div className={cx(styles['quantity-text'], { [styles['disabled']]: disabled })}>
					<input type="text" value={quantity} onChange={this.changeQuantity(QuantityChangeAction.INPUT)} className={styles['quantity-input']} disabled={disabled} onBlur={this.handleBlur} data-aid="cart-quantity"/>
				</div>
				<button className={cx(styles['quantity-button'], styles['quantity-add'])} onClick={this.changeQuantity(QuantityChangeAction.ADD)} disabled={disabled} data-aid="add-quantity">
					{' '}
					+{' '}
				</button>
			</div>);
    }
}
